import React, { useState, useEffect } from "react";
import EditDocComponent from "./SyncButton.jsx";
import { useParams, useLocation } from "react-router-dom";
import { API_URL } from "../utils/Constant.jsx";
import { message } from "antd";
import axiosInstance from "../utils/axiosInstance.js";
import { useSelector } from "react-redux";

message.config({
  top: 100,
});

const MyComponent = () => {    
  const select = useSelector((state) => state.auth.userInfo);
  const userName =  select.name;
  const { params } = useParams();
  const location = useLocation();
  const [agreementFile, setAgreementFile] = useState(null);
  const [hasBeenShown, setHasBeenShown] = useState(false);
  const companyId = localStorage.getItem("companyId") || select.company_id; 

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const agreementFileParam = query.get("agreementFile");
    if (agreementFileParam) {
      setAgreementFile(decodeURIComponent(agreementFileParam));
    }
  }, [location.search]);

  const { pk } = useParams(); 
  const handleDocumentEditorClose = async (blob) => {
    setHasBeenShown(true);
    const file = new File([blob], "document.docx", { type: blob.type });
    const formData = new FormData();
    formData.append("agreement_id", pk);
    formData.append("agreement_file", file);
    formData.append("company_id", companyId);
    try {
      const response = await axiosInstance.post( `/contract/save_agreement_file/`, formData );
      if (response) {
        message.open({
          type: "success",
          content: response.data.message,
          className: "custom-class",
          style: {
            marginTop: "2vh",
          },
        });
      }
      setHasBeenShown(false);
    } catch (error) {
      message.open({
        type: "error",
        content: error.response.data.message,
        className: "custom-class",
        style: {
          marginTop: "2vh",
        },
      });
      setHasBeenShown(false);
      console.error("Error sending file to backend:", error);
    }
    const blobData = new Blob([JSON.stringify({ formData })], {
      type: "application/json",
    });

    navigator.sendBeacon(API_URL + "/contract/save_agreement_file/", blobData);
  };
  return (
      <EditDocComponent
        fileUrl={agreementFile && agreementFile}
        userName={userName}
        onClose={handleDocumentEditorClose}
        hasBeenShown={hasBeenShown}
      />
  );
};

export default MyComponent;
